import {
  Dialog,
  DialogContent,
  Box,
  LinearProgress,
  Link,
  DialogActions,
} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";

import { getExplorerUrl } from "../../../libs/aptos_sdk";
import StepCard from "../../Swap/StepCard";
import Button from "../Button";
import Transition from "../Transition";

type TransactionDialogProps = {
  openAlert: boolean;
  txn: string;
  title: string;
  step: number;
  handleCloseAlert: Function;
};
const TransactionDialog: React.FC<TransactionDialogProps> = ({
  openAlert,
  txn,
  title,
  step,
  handleCloseAlert,
}) => {
  return (
    <Dialog
      open={openAlert}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ alignContent: "center" }}>
        <Box sx={{ width: "100%" }}>
          {step === 3 && <LinearProgress variant="determinate" />}
        </Box>
        <br />

        <StepCard step={step} />

        <br />
        {txn && (
          <Link
            width={400}
            component="button"
            onClick={() => {
              const w = window.open("about:blank");
              if (w) {
                w.location.href = getExplorerUrl(txn);
              }
            }}
            variant="body2"
          >
            View on Explorer
          </Link>
        )}
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={() => handleCloseAlert()}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransactionDialog;
